import { IncludeType } from '../../../common';
import { Group } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches accessories for a specific group by its ID.
 *
 * @param groupId - The ID of the group to fetch accessories for.
 * @param locale - The locale for the market.
 * @param includeType - Specifies the type of accessories to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to an array of `Group` objects or `null` if no data is found.
 */
export const getGroupAccessories = async (
  groupId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Group[] | null> => {
  try {
    const queryParams = new URLSearchParams({
      include: includeType,
      marketLocale: locale,
    }).toString();

    const url = `/group/${groupId}/accessories?${queryParams}`;
    const response = await productCatalogueHttp.get<Group[]>(url);

    return response?.data?.length ? response.data : null;
  } catch (error) {
    console.error(`Failed to fetch group accessories for groupId: ${groupId}`, error);
    return null;
  }
};
